import { render, staticRenderFns } from "./SelectTemplate.vue?vue&type=template&id=08d7105c&"
import script from "./SelectTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports